export default __webpack_public_path__ + "static/media/project.afa176f9.svg";